import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import {
	setModoTela, initForm
} from './incubacaoMaturidadeAno3Actions';
import {
	setModoTela as setModoTelaIncubacao
} from '../incubacao/incubacaoActions';
import consts from '../consts';
import ClipboardImageHandler from '../common/form/ClipboardImageHandler';
import TextoInput from '../texto/textoInput';
import LabelAndInputDate from '../common/form/labelAndInputDate';

class IncubacaoMaturidadeAno3Form extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao ? 'readOnly' : '';

		
		return (
			<Row alignCenter>
				<Grid cols='12 10 8 5'
					style={{ padding: 0 }}>
					<ContentCard 
						style={{
							marginTop: 20,
							backgroundColor: '#0F2748',
							color: '#ffffff',
							borderRadius: 20,
							boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
							opacity: '80%'
						}}>
						<ContentCardHeader
							style={{
								marginTop: 16,
								marginBottom: 16
							}}>
							<label>{this.props.incubacaoMaturidadeAno3FormTitulo}</label>

							{!this.props.modoAdm &&
							<TextoInput chave='incubacaoMaturidadeAno3FormTitulo' />}
						</ContentCardHeader>
						<Form event={this.props.handleSubmit}>
							<ContentCardBody>
								
							<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>FINANCEIRO</h4>
								</Row>
								
								<Row>
									<Field
											name='financeiro_cac'
											component={LabelAndInputNumber}
											label='Custo de aquisição de clientes: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
									
									<Field
											name='financeiro_faturamento'
											component={LabelAndInputNumber}
											label='Faturamento do período: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
									
									<Field
											name='financeiro_custo_fixo'
											component={LabelAndInputNumber}
											label='Custos fixos mensais: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
									
									<Field
											name='financeiro_custo_variavel'
											component={LabelAndInputNumber}
											label='Custos Variáveis do período: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
									
									<Field
											name='financeiro_lucro'
											component={LabelAndInputNumber}
											label='Lucratividade: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
									
									<Field
											name='financeiro_investimento'
											component={LabelAndInputNumber}
											label='Volume de recursos captados em investimentos: *' placeholder=''
											cols='12 12 12 12'
											readOnly={readOnly}
											casas={2} />
								</Row>

								<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>MERCADO</h4>
								</Row>
								<Row>
									<Field
										name='mercado_propspects'
										component={LabelAndInputNumber}
										label='Número de clientes Prospectados: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={0} />
									
									<Field
										name='mercado_clientes'
										component={LabelAndInputNumber}
										label='Número de clientes ativos: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={0} />
									
									<Field
										name='mercado_satisfacao'
										component={LabelAndInputNumber}
										label='Índice de satisfação dos clientes: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />
									
									<Field
										name='mercado_recorrencia'
										component={LabelAndInputNumber}
										label='Percentual de receita recorrente: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />
								</Row>

								<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>GESTÃO</h4>
								</Row>
								 
								<Row>
									<Grid cols='12 12 12 12'
										style={{
											marginBottom: 12
										}}>

										<p>Organograma da empresa:</p>

										{(this.props.formularioValues.gestao_organograma || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', padding: 10 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={pdfAdicionado} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-primary'
														style={{ width: '48%' }}
														disabled={arquivo.arquivo_base64 ? true : false}
														onClick={() => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>
													<button
														type='button'
														class='btn btn-flat btn-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																gestao_organograma: this.props.formularioValues.gestao_organograma.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										
										<ClipboardImageHandler
											id='gestao_organograma'
											label='Use Ctrl+V para colar ou arraste e solte anexos aqui.'
											msgErro='Selecione apenas (.PDF)'
											types={[
												'application/pdf'
											]}
											onChange={result => {

												let lista = (this.props.formularioValues.gestao_organograma || []).map(item => item);
												lista.push({
													arquivo_base64: result
												});
												this.props.initForm({
													...this.props.formularioValues,
													gestao_organograma: lista
												});
											}} />
									</Grid>
								</Row>
								<Row>
									<Field
										name='gestao_metas'
										component={LabelAndInputNumber}
										label='Percentual de metas atingidas: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />

									<Field
										name='gestao_participacao'
										component={Select}
										options={[
											{ id: 'Participa', valor: 'Participa' },
											{ id: 'Não Participa', valor: 'Não Participa' }
										]}
										label='Participação nas atividades da incubadora: *' placeholder=''
										cols='12 12 12 12' />
								</Row>

								<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>INOVAÇÃO</h4>
								</Row>
								<Row>
									<Field
										name='inovacao_desenvolvimento'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Não', valor: 'Não' }
										]}
										label='Desenvolvimento de novos produtos/processos/serviços: *' placeholder=''
										cols='12 12 12 12' />
									
									<Field
										name='inovacao_editais'
										component={LabelAndInputNumber}
										label='Volume de recursos captados em editais de Inovação: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={2} />
									
									<Field
										name='inovacao_registro_patente'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Encaminhado', valor: 'Encaminhado' },
											{ id: 'Não', valor: 'Não' },
											{ id: 'Não se aplica', valor: 'Não se aplica' }
										]}
										label='Pedido de Patente: *' placeholder=''
										cols='12 12 12 12' />
									
									<Field
										name='inovacao_registro_software'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Encaminhado', valor: 'Encaminhado' },
											{ id: 'Não', valor: 'Não' },
											{ id: 'Não se aplica', valor: 'Não se aplica' }
										]}
										label='Registro de Software: *' placeholder=''
										cols='12 12 12 12' />
									
									<Field
										name='inovacao_registro_marca'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Encaminhado', valor: 'Encaminhado' },
											{ id: 'Não', valor: 'Não' },
											{ id: 'Não se aplica', valor: 'Não se aplica' }
										]}
										label='Registro de Marca: *' placeholder=''
										cols='12 12 12 12' />
								</Row>
								<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>PESSOAS</h4>
								</Row>
								<Row>
									<Field
										name='pessoas_colaboradores'
										component={LabelAndInputNumber}
										label='Número de colaboradores incluindo os sócios: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={0} />
									
									<Field
										name='pessoas_dedicacao'
										component={LabelAndInputNumber}
										label='Número de pessoas com dedicação Exclusiva: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={0} />
									
									<Field
										name='pessoas_grau_instrucao'
										component={LabelAndInput}
										label='Grau de Instrução: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />
									
									<Field
										name='pessoas_horas'
										component={LabelAndInputNumber}
										label='Número de horas de horas de desenvolvimento (cursos, eventos, missões): *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly}
										casas={0} />
								</Row>

								<Row alignCenter
									style={{
										marginTop: 8,
										marginBottom: 16,
										backgroundColor: '#07162b',
										color: '#ffffff',
										borderRadius: 4
									}}>
									<h4 style={{ paddingTop: 8, paddingBottom: 8, margin: 0, textAlign: 'center' }}>SUSTENTABILIDADE</h4>
								</Row>
								<Row>
									<Field
										name='sustentabilidade_ods'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Não', valor: 'Não' }
										]}
										label='Contribui com as metas dos objetivos de desenvolvimento sustentável: *' placeholder=''
										cols='12 12 12 12' />
									
									<Field
										name='sustentabilidade_residuo'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Não', valor: 'Não' }
										]}
										label='Gera algum tipo de resíduo que impacto o meio ambiente: *' placeholder=''
										cols='12 12 12 12' />
									
									{this.props.formularioValues.sustentabilidade_residuo == 'Sim' &&
									<Field
										name='sustentabilidade_residuo_quais'
										component={LabelAndInput}
										label='Informe quais residuos são gerados: *' placeholder=''
										cols='12 12 12 12'
										readOnly={readOnly} />}
									
									<Field
										name='sustentabilidade_social'
										component={Select}
										options={[
											{ id: 'Sim', valor: 'Sim' },
											{ id: 'Não', valor: 'Não' }
										]}
										label='Contribui com projeto social: *' placeholder=''
										cols='12 12 12 12' />
									
								</Row>

								<Row alignCenter>
									{!this.props.visualizacao &&
									<Grid cols='8 8 8 8'>
										{this.props.excluir ? (
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										) : (
										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'} />
										)}
									</Grid>}
									{!this.props.modoAdm ? (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
										</Grid>
									) : (
										<Grid cols='4 4 4 4'>
											<Button
												text='Voltar'
												type={'success'}
												icon={'fa fa-chevron-left'}
												event={() => this.props.setModoTelaIncubacao('trilha')} />
										</Grid>
									)}
								</Row>
							</ContentCardBody>
						</Form>
					</ContentCard>
				</Grid>
			</Row>
		);
    }


}

IncubacaoMaturidadeAno3Form = reduxForm({form: 'incubacaoMaturidadeAno3Form', destroyOnUnmount: false})(IncubacaoMaturidadeAno3Form);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('incubacaoMaturidadeAno3Form')(state),
	registro: state.incubacaoMaturidadeAno3.registro,
	lista: state.incubacaoMaturidadeAno3.lista,
	incubacaoMaturidadeAno3FormTitulo: state.texto.lista.filter(item => item.chave == 'incubacaoMaturidadeAno3FormTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, 
	setModoTelaIncubacao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoMaturidadeAno3Form);
